import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'shared/api/client';
import ServerErrorHandler from 'shared/feedback/ErrorHandler';
import { organizationKeys } from './keys';

export const useOrganizations = (enabled = true) =>
  useQuery({
    queryKey: organizationKeys.list(),

    queryFn: async () => {
      const { data } = await api.GET('/organizations/');
      return data;
    },

    enabled,
  });

export const useCreateOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ name }: { name: string }) => api.POST('/organizations/', { body: { name } }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: organizationKeys.list(),
      });
    },

    onError: ServerErrorHandler,
  });
};
